import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    //登录弹窗
    loginshow:false,
    //头部模板 登录/注册 显示
    loginstate:false,
    //点击展开登录弹窗 1登录 2注册 3忘记密码
    log:'1'
  },
  // getters,
  actions,
  mutations
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js